import React, {useMemo} from 'react';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import Translate from '../../../../../../src/components/Translate/Translate';
import MessageReceiver, {
    makeOnDeleteAttachListener,
    makeOnDropAttachListener
} from '../../../../../../src/components/Chat/MessageReceiver/MessageReceiver';
import AttachmentsPreviews from '../../../../../../src/components/Chat/AttachmentsPreviews/AttachmentsPreviews';

const emptyArray = [] as const;

export default function CommentField({formId, isDisabled}: {
    formId: string,
    isDisabled?: boolean,
}) {
    const {control, setValue} = useFormContext();
    const attachments = useWatch({control, name: 'comment.attachments'});

    const [onDelete, onDrop] = useMemo(() => {
        const set = (value: File[] | ((list: File[]) => File[])) => {
            if (typeof value === 'function') {
                value = value(attachments ?? []);
            }

            setValue('comment.attachments', value);
        };

        return [
            makeOnDeleteAttachListener(set),
            makeOnDropAttachListener(set),
        ];
    }, [attachments, setValue]);

    return <Controller
            name="comment.message"
            control={control}
            render={({field: {value, onChange}, fieldState: {error}}) => {
                return <>
                    <Translate<HTMLLabelElement>
                            message="TaskForm.change-status.fields.comment"
                            tag="label"
                            className="col-form-label-sm col-form-label"
                    />

                    <MessageReceiver
                            placeholder="TaskForm.change-status.fields.comment"
                            defaultValue={value}
                            onInput={onChange}
                            onDrop={onDrop}
                            isInvalid={Boolean(error)}
                            isDisabled={isDisabled}
                            errorMessage={error?.message}
                            filesPreviewSlot={
                                <AttachmentsPreviews attachment={attachments ?? emptyArray} onDelete={onDelete}/>
                            }
                            size="sm"
                            formId={formId}
                    />
                </>;
            }}
    />;
}
